import MainLayout from "../../layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../components/modal/delete-modal";
import { TextView } from "../../components/view-form-components/text-view";
import { useEffect } from "react";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";

const ViewExpense = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.expense;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/expense/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/expense/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/expense/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">
            Tile layer - view
          </h2>
          <div className="flex gap-3 items-center">
            {permission?.write && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/expense/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {permission?.write && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <TextView label={"Title"} value={data?.title} />
          </div>
          <div className="px-2">
            <TextView label={"Amount"} value={data?.amount} />
          </div>
          <div className="px-2">
            <TextView label={"Date"} value={data?.date} />
          </div>

          <CommentsComponent tableName={"expense"} viewId={params?.id} />
          <FileCommentComponent tableName={"expense"} viewId={params?.id} />
        </section>
      </section>
    </MainLayout>
  );
};

export default ViewExpense;
